import React, { useState, useEffect, Fragment } from "react";
import { Link } from "#/renderer/router";

const BreadcrumbLevel = ({ label, link = null, active = false, isRoot = false }) => {

  const color = active ? '#da291c' : '#bbb'

  return (
    <Fragment>
      {
        !isRoot && (
          <span style={{ width: '15px', textAlign: 'center', color }}>/</span>
        )
      }

      {
        link && <Link style={{ color }} to={link}>{label}</Link>
      }
      {
        !link && <span style={{ color }}>{label}</span>
      }
      {/* <span style={{ color }}>{label}</span> */}
    </Fragment>
  )

}

const Breadcrumb = ({
  breadcrumbItems = [],
}) => (
  <div className="header--breadcrumb1">
    <nav>
      {
        breadcrumbItems.map((item, index) => (
          <Fragment key={index}>
            <BreadcrumbLevel
              label={item.label}
              link={item.link}
              active={index === breadcrumbItems.length - 1}
              isRoot={index === 0}
            />
          </Fragment>
        ))
      }
      {/* <Link to="/">Tienda</Link>
      <BreadcrumbLevel
        label={macroCategoryLabel}
      />
      <BreadcrumbLevel
        label={productLabel}
      />

      <span>{activeCategory?.locales?.[process.env.NEXT_PUBLIC_LOCALE]?.name?.value}</span> */}
    </nav>
  </div>
);

export default Breadcrumb;
